import React from "react";
import { useSelector } from "react-redux";
import styled from "@emotion/styled";
import dayjs from "dayjs";

import { ReactComponent as LastTime } from "../../../../assets/LastTime.svg";
import colors from "../../../../common/styles/colors";
import { RootState } from "../../../../redux/store";
import { COUNTRY_CODES } from "common/constants";

const Container = styled.div`
  position: absolute;
  bottom: 16px;
  left: 16px;
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    color: ${colors.grey[600]};
    font-weight: 400;
    font-size: 14px;
    line-height: 32px;
    letter-spacing: 0px;
  }
`;

export const FreyaLastConnectionDateTimeIndicator = () => {
  const lastBadgeUpdateTime = useSelector((state: RootState) => state.metadata.lastBadgeUpdateTime);
  const eventCountry = useSelector((state: RootState) => state.eventEdition.cmsEventDetails?.siteDetails.address.country);

  const isEventCountryUSA = eventCountry === COUNTRY_CODES.USA;
  const formattedLastBadgeUpdateTime = isEventCountryUSA
    ? dayjs(lastBadgeUpdateTime).format("MM-DD-YY, HH:mm")
    : dayjs(lastBadgeUpdateTime).format("DD-MM-YY, HH:mm");

  if (!lastBadgeUpdateTime) return null;

  return (
    <Container data-testid="freya-last-connection-indicator">
      <LastTime />

      <span data-testid="freya-last-connection-time">{formattedLastBadgeUpdateTime}</span>
    </Container>
  );
};
